var util = require('../lib/util.es6');
var re = require('../lib/re.es6');


// http://en.wikichip.org/wiki/irc/colors
// https://github.com/myano/jenni/wiki/IRC-String-Formatting

/* Public API */

function renderHtml (text, options) {
    var tokens = tokenize(text, options);
    var output = '';
    var inBlock = false;
    var atMention = false;
    var openQuote, closeQuote, lastOpenQuote, lastCloseQuote = false;
    if (options.stripDisplayName) {
        var strippedOutput = '';
        var stripMatchStartRe = /^[<`\[]/;
        var stripMatchRe = new RegExp('^[<`\\[]' + re.escape(options.stripDisplayName) + '[>`\\]]:? ');
        var closeMatchRe;
    }
    for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] === TOKEN_CONST.OPEN_BLOCK) {
            inBlock = true;
        } else if (tokens[i] === TOKEN_CONST.CLOSE_BLOCK) {
            inBlock = false;
        }
        atMention = (isStringObj(tokens[i-1]) && _.last(tokens[i-1].val) === '@');
        openQuote = (
            tokens[i] === TOKEN_CONST.OPEN_QUOTE ||
            tokens[i] === TOKEN_CONST.OPEN_QUOTE_SPACE
        );
        closeQuote = (
            tokens[i] === TOKEN_CONST.CLOSE_QUOTE ||
            tokens[i] === TOKEN_CONST.CLOSE_QUOTE_SPACE
        );
        // Fill empty quote
        if (lastOpenQuote && closeQuote) {
            output += '&nbsp;';
        }
        // Trim newline before quote
        if (openQuote) {
            output = output.replace(/\n$/, '');
        }
        if (options.stripDisplayName) {
            strippedOutput += stripZWSP(renderTokenStrip(tokens[i]));
            if (strippedOutput && !strippedOutput.match(stripMatchStartRe)) {
                // if output but no open match, abort
                options.stripDisplayName = false;
            } else {
                var fullMatch = strippedOutput.match(stripMatchRe);
                if (fullMatch) {
                    // split on close
                    if (strippedOutput[0] == '<') {
                        closeMatchRe = />:? /;
                    } else if (strippedOutput[0] == '`') {
                        closeMatchRe = /`?:? /;
                    } else if (strippedOutput[0] == '[') {
                        closeMatchRe = /\]:? /;
                    }
                    var closeMatch = tokens[i].val.match(closeMatchRe);
                    var slice = 0;
                    if (closeMatch) {
                        slice = closeMatch.index + closeMatch[0].length;
                    } else if (tokens[i].val.match(/^ /)) {
                        // Fallback to just slicing the space off, if no close
                        // match then match was in previous token
                        slice = 1;
                    }
                    output = '';
                    tokens[i].val = tokens[i].val.slice(slice);
                    options.stripDisplayName = false;
                }
            }
        }
        output += renderTokenHtml(tokens[i], _.extend({}, options, {
            atMention: atMention,
            inBlock: inBlock,
            tokens: tokens,
            lastCloseQuote: lastCloseQuote
        }));
        lastOpenQuote = openQuote;
        lastCloseQuote = closeQuote;
    }
    return stripControl(output);
}
function strip (text, options) {
    var tokens = tokenize(text, options);
    var output = '';
    for (var i = 0; i < tokens.length; i++) {
        output += renderTokenStrip(tokens[i], options);
    }
    return stripControl(output);
}
function stripRegex (text, options) {
    options = options || {};
    var output = stripControl(stripFormat(text));
    if (options.processor) {
        return options.processor(output, options);
    } else {
        return output;
    }
}

function stripPreformatted (text) {
    return text.replace(RE.block, '');
}

function stripZWSP (text) {
    return text.replace(/\u200B/g, '');
}

function stripFormat (text) {
    // Strips colours and formatting
    return text.replace(RE.color, '')
        .replace(RE.hex, '')
        .replace(RE.formatting, '');
}
        
/* Token renderers */

function stripControl (text) {
    return text.replace(RE.control, '');
}
function allSpaces (text) {
    return RE.all_space.test(text);
}
function space2nspb (text) {
    return text.replace(RE.space, '&nbsp;');
}
function escapeHtmlLinuxNotification (text) {
    return escapeHtmlMinimal(text);
}
function escapeHtmlMinimal (text) {
    text = util.stringify(text);
    return text
        .replace(RE.amp, '&amp;')
        .replace(RE.lt, '&lt;')
        .replace(RE.gt, '&gt;')
        .replace(RE.double_quote, '&quot;');
}
function escapeHtml (text, options) {
    options = options || {};
    text = util.stringify(text);
    if (!options.rawSpace && allSpaces(text)) {
        return space2nspb(text);
    } else {
        var repl = text
            .replace(RE.amp, '&amp;')
            .replace(RE.lt, '&lt;')
            .replace(RE.gt, '&gt;')
            .replace(RE.double_quote, '&quot;')
            .replace(RE.single_quote, '&#x27;')
            .replace(RE.slash, '&#x2f;');
        if (options.rawSpace) {
            return repl;
        } else {
            return repl.replace(RE.start_space, space2nspb);
        }
    }
}

// Strip
function renderTokenStrip (token, options) {
    options = options || {};
    if (isStringObj(token)) {
        // Process strings if there's a processor
        if (options.processor) {
            return options.processor(token.val, token.index, options);
        } else {
            return token.val;
        }
    } else if (isCodeBlock(token)) {
        return BLOCK;
    } else if (isCodeSpan(token)) {
        return CODE;
    } else if (token === TOKEN_CONST.OPEN_QUOTE) {
        return QUOTE;
    } else if (token === TOKEN_CONST.OPEN_QUOTE_SPACE) {
        return QUOTE + ' ';
    }
    // Strip everything else
    return '';
}

// HTML
function renderTokenHtml (token, options) {
    if (isStringObj(token)) {
        return renderStringHtml(token, options);
    } else if (isNumber(token)) {
        // Formatting tokens
        if (token == TOKEN_CONST.CLOSE_COLOR && options.noColor) {
            return '';
        }
        return TOKEN_TAGS[token];
    } else if (isColorObj(token)) {
        // Color objects
        if (options.noColor) {
            return '';
        }
        return renderColorHtml(token);
    } else {
        // Shouldn't match anything else
        debug.warn('IRCFormatter: non string, object, number token', token, options);
        return '';
    }
}
function renderStringHtml (token, options) {
    options = options || {};
    var val = token.val;
    // Trim newline after quote
    if (options.lastCloseQuote) {
        val = val.replace(/^\n/, '');
    }
    // Process strings if there's a processor
    if (options.processor) {
        return options.processor(val, token.index, options);
    } else {
        // Escape html chars by default
        return escapeHtml(val);
    }
}
function renderColorHtml (colorToken) {
    var classNames = [];
    var styles = [];
    var fg = colorToken.fg;
    var rgb = colorToken.rgb;
    var rgbfg = rgb;
    var rgbbg = rgb;
    var bg = colorToken.bg || colorToken._bg;
    var inv = colorToken.inv;
    if (inv) {
        var _fg, _bg;
        if (fg) {
            _bg = fg;
        } else {
            _bg = 'inverse';
            rgbbg = false;
        }
        if (bg) {
            _fg = bg;
        } else {
            _fg = 'inverse';
            rgbfg = false;
        }
        fg = _fg;
        bg = _bg;
    }
    if (fg) {
        if (rgbfg) {
            styles.push('color:#' + fg);
        } else if (COLOR_MAP[fg]) {
            classNames.push('irccolor ' + COLOR_MAP[fg]);
        } else if (EXTENDED_COLOR_MAP[fg]) {
            styles.push('color:#' + EXTENDED_COLOR_MAP[fg]);
        }
    }
    if (bg) {
        if (rgbbg) {
            styles.push('background-color:#' + bg);
        } else if (COLOR_MAP[bg]) {
            classNames.push('irccolor-bg bg-' + COLOR_MAP[bg]);
        } else if (EXTENDED_COLOR_MAP[bg]) {
            styles.push('background-color:#' + EXTENDED_COLOR_MAP[bg]);
        }
    }
    var classAttr = '';
    var styleAttr = '';
    if (classNames.length) {
        classAttr = ' class="' + classNames.join(' ') + '"';
    }
    if (styles.length) {
        styleAttr = ' style="' + styles.join(';') + '"';
    }
    return '<wbr><span' + classAttr + styleAttr + '>';
}

/* Internal API */

function tokenizeQuoted (text, list, state, index, options) {
    options = options || {};
    var initialIndex = index;
    var lengthIndex = index;
    var textString = text.join('');
    var blockquoteMatch = textString.match(RE.blockquote_one);
    if (blockquoteMatch) {
        var codeBlockMatch = textString.match(RE.block_one);
        if (codeBlockMatch && codeBlockMatch.index < blockquoteMatch.index) {
            return;
        }
        textString.replace(RE.blockquote, function (matchPart, inner, matchIndex, full) {
            var between = textString.slice(lengthIndex-initialIndex, matchIndex);
            if (between) {
                var betweenChars = util.arrayFrom(between);
                index += tokenizeQuoteRest(betweenChars, list, state, index, options);
                lengthIndex += between.length;
            }

            var token = 'QUOTE';
            index += QUOTE.length;
            lengthIndex += QUOTE.length;
            if (inner && inner[0] == ' ') {
                token = 'QUOTE_SPACE';
                inner = inner.slice(1);
                index++;
                lengthIndex++;
            }
            pushToken(token, list, state);

            if (inner) {
                var innerChars = util.arrayFrom(inner);
                index += tokenizeQuoteRest(innerChars, list, state, index, _.extend({}, options, {quoted: true}));
                lengthIndex += inner.length;
            }

            pushToken(token, list, state);
        });
        var final = textString.slice(lengthIndex-initialIndex);
        if (final) {
            var finalChars = util.arrayFrom(final);
            index += tokenizeQuoteRest(finalChars, list, state, index, options);
        }
        return index;
    }
}

function tokenizePlain (text, list, state, index, options) {
    var length = text.length;
    for (var i = 0; i < text.length; i++) {
        var repl_part, repl_length_diff;
        if (options.replacement_parts && (repl_part = options.replacement_parts[index + i])) {
            pushString(list, repl_part.join(''), index + i);
            // Replacing 'a' character
            repl_length_diff = repl_part.length - 1;
            index += repl_length_diff;
            length += repl_length_diff;
        } else {
            parseToken(text[i], list, state, index + i, options);
        }
    }
    return length;
}

function tokenizePreformatted (text, list, state, index, re, token, label, options, tokenizeRestFun) {
    var initialIndex = index;
    var lengthIndex = index;
    var textString = text.join('');
    if (textString.match(re)) {
        textString.replace(re, function (matchPart, inner, after, matchIndex, full) {
            if (full === undefined) {
                full = matchIndex;
                matchIndex = after;
                after = '';
            }
            var between = textString.slice(lengthIndex-initialIndex, matchIndex);
            if (between) {
                var betweenChars = util.arrayFrom(between);
                index += tokenizeRestFun(betweenChars, list, state, index, options);
                lengthIndex += between.length;
            }

            if (inner.indexOf(BLOCK) === 0 || inner.indexOf(token) === 0) {
                // Abort if inner starts with block marker or code marker for code spans
                var matchPartChars = util.arrayFrom(matchPart);
                index += tokenizeRestFun(matchPartChars, list, state, index, options);
                lengthIndex += matchPart.length;
            } else {
                // Handle inner
                pushToken(label, list, state);
                index += token.length;
                lengthIndex += token.length;

                var innerChars = util.arrayFrom(inner);
                index += tokenizeRestFun(innerChars, list, state, index, _.extend({}, options, {preformatted: true}));
                lengthIndex += inner.length;

                pushToken(label, list, state);
                index += token.length;
                lengthIndex += token.length;

                // Handle after
                if (after) {
                    var afterChars = util.arrayFrom(after);
                    pushString(list, after, index);
                    index += afterChars.length;
                    lengthIndex += after.length;
                }
            }
        });
        var final = textString.slice(lengthIndex-initialIndex);
        if (final) {
            var finalChars = util.arrayFrom(final);
            index += tokenizeRestFun(finalChars, list, state, index, options);
        }
        return index;
    }
}

function postFormat (text, list, state, index, options) {
    options = options || {};
    var newIndex;
    if (options.quote && (newIndex = tokenizeQuoted(
        text, list, state, index, options
    ))) {
        return newIndex;
    } else {
        return tokenizeQuoteRest(text, list, state, index, options);
    }
}

function tokenizeQuoteRest (text, list, state, index, options) {
    var newIndex;
    if (options.codeBlock && (newIndex = tokenizePreformatted(
        text, list, state, index, RE.block, BLOCK, 'BLOCK', options, tokenizeCodeRest
    ))) {
        return newIndex;
    } else {
        return tokenizeCodeRest(text, list, state, index, options);
    }
}

function tokenizeCodeRest (text, list, state, index, options) {
    var newIndex;
    if (!options.preformatted && options.codeSpan && (newIndex = tokenizePreformatted(
        text, list, state, index, RE.code, CODE, 'CODE', options, tokenizePlain
    ))) {
        return newIndex;
    }
    return tokenizePlain(text, list, state, index, options);
}

function tokenizeReplacements (text, list, state, index, options) {
    var repl_parts = {};
    var repl_index = 0;
    var repl_placeholder = [];
    _.each(options.replacements, function (replacement) {
        var rOffset = replacement.startOffset || 0;
        var rStart = rOffset + replacement.start;
        var rEnd = rOffset + replacement.end;
        if (
            rStart >= 0 &&
            rStart <= text.length &&
            rEnd <= text.length
        ) {
            var repl_before = text.slice(repl_index, rStart);
            if (repl_before) {
                repl_placeholder = repl_placeholder.concat(repl_before);
            }
            var repl_text = text.slice(rStart, rEnd);
            repl_parts[rStart] = repl_text;
            repl_placeholder.push('a');
            repl_index = rEnd;
        }
    });
    var repl_after = text.slice(repl_index);
    if (repl_after) {
        repl_placeholder = repl_placeholder.concat(repl_after);
    }
    return postFormat(repl_placeholder, list, state, index, _.extend({}, options, {
        replacement_parts: repl_parts
    }));
}

function isQuote (text) {
    return RE.blockquote_one.test(text);
}

function tokenize (text, options) {
    options = _.extend({}, options, {
        isFormatted: RE.format_one.test(text)
    });
    text = util.arrayFrom(util.stringify(text));
    var list = [];
    var state = [];
    var index = 0;
    if (options && options.replacements) {
        index += tokenizeReplacements(text, list, state, index, options);
    } else {
        index += postFormat(text, list, state, index, options);
    }

    clearEmptyColor(list, state);
    initPrevColorState(list, state, index);
    normalise(list);
    // Clear all state
    clearState(list, state, true);
    return list;
}

// Update state and token list
function pushToken (token, list, state) {
    var lastStateIndex = lastIndexOf(token, state);
    if (lastStateIndex !== -1) {
        // Character is a close tag

        // Close any colors and reopen after
        // Also make any open code tags inert if this isn't a code token
        var colorCount = 0;
        var i;
        for (i = state.length - 1; i > lastStateIndex; i--) {
            if (token !== 'CODE' && state[i] === 'CODE') {
                var openCodeIndex = lastIndexOf(TOKEN_CONST['OPEN_CODE'], list);
                state.splice(i, 1, 'INERT_CODE');
                list.splice(openCodeIndex, 1, TOKEN_CONST['OPEN_INERT_CODE']);
            } else if (state[i] === 'COLOR') {
                state.splice(i, 1);
                pushCloseColor(list);
                colorCount++;
            }
        }
        var colors = [];
        for (i = list.length - 1; colorCount > 0 && i >= 0; i--) {
            if (isColorObj(list[i])) {
                colors.push(list[i]);
                colorCount--;
            }
        }
        // Push the code onto the list and remove state token
        state.splice(lastStateIndex, 1);
        list.push(TOKEN_CONST['CLOSE_' + token]);
        // Reopen colors
        while (colors.length) {
            var color = _.clone(colors.pop());
            if (colors.length > 1) {
                state.push('COLOR');
            } else if (!isEmptyColor(color)) {
                color.complete = true;
            }
            list.push(color);
        }
    } else {
        // Character is an open tag

        // Check for inert_code
        var lastInertCodeIndex = lastIndexOf('INERT_CODE', state);
        if (token === 'CODE' && lastInertCodeIndex !== -1) {
            state.splice(lastInertCodeIndex, 1);
            list.push(TOKEN_CONST['CLOSE_INERT_CODE']);
        } else {
            // Push the code onto the list and add a state token
            state.push(token);
            list.push(TOKEN_CONST['OPEN_' + token]);
        }
    }
}
// Close all formatting state in reverse
function clearState (list, state, final) {
    clearEmptyColor(list, state);
    var stateRestore = [];
    while (state.length) {
        var token = state.pop();
        if (!final && (
            token === 'QUOTE' ||
            token === 'QUOTE_SPACE' ||
            token === 'BLOCK' ||
            token === 'CODE'
        )) {
            stateRestore.push(token);
        } else {
            var tokConst = TOKEN_CONST['CLOSE_' + token];
            if (tokConst) {
                list.push(tokConst);
            }
        }
    }
    while (stateRestore.length) {
        state.push(stateRestore.pop());
    }
    if (list.length && isColorObj(list[list.length-1])) {
        pushCloseColor(list);
    }
}
// Close colored state and token list
function closeColor (list, state, omitToken) {
    for (var i = state.length - 1; i >= 0; i--) {
        if (state[i] === 'COLOR') {
            state.splice(i, 1);
            if (!omitToken) {
                pushCloseColor(list);
            }
        }
    }
}
function pushCloseColor (list) {
    list.push(TOKEN_CONST.CLOSE_COLOR);
}

// Detect color object
function isColorObj (obj) {
    return isObject(obj) && !isStringObj(obj);
}
function isStringObj (obj) {
    return isObject(obj) && ('val' in obj) && ('index' in obj);
}
function isEmptyColor (obj) {
    return (isColorObj(obj) && !obj.fg && !obj.bg && !obj.inv);
}
function isCodeBlock (token) {
    return (
        token === TOKEN_CONST.OPEN_BLOCK ||
        token === TOKEN_CONST.CLOSE_BLOCK
    );
}
function isCodeSpan (token) {
    return (
        token === TOKEN_CONST.OPEN_CODE ||
        token === TOKEN_CONST.CLOSE_CODE ||
        token === TOKEN_CONST.OPEN_INERT_CODE ||
        token === TOKEN_CONST.CLOSE_INERT_CODE
    );
}
// Clear any preceding empty colors
function clearEmptyColor (list, state) {
    if (list.length && isEmptyColor(list[list.length-1])) {
        // Empty color object, remove it and update state and token list
        list.pop();
        closeColor(list, state, true);
    }
}

// Go into COLORed state and start a new string
function endColorParse (chr, list, state, index) {
    state.push('COLOR');
    pushString(list, chr, index);
}

function currentColorCopyDefault (list, state, rgb) {
    var color = currentColorCopy(list, state);
    if (rgb != color.rgb) {
        if (rgb) {
            return {rgb: true};
        } else {
            return {};
        }
    }
    if ('bg' in color) {
        color._bg = color.bg;
        delete color.bg;
    }
    delete color.fg;
    return color;
}

function currentColorCopy (list, state) {
    var currentColor;
    var isColorState = false;
    var i;
    if (lastIndexOf('COLOR', state) !== -1) {
        for (i = list.length - 1; !currentColor && i >= 0; i--) {
            if (isColorObj(list[i])) {
                currentColor = _.clone(list[i]);
                delete currentColor.complete;
            }
        }
    }
    if (!currentColor) {
        currentColor = {};
        for (i = state.length - 1; i >= 0; i--) {
            if (state[i] === 'INVERSE') {
                currentColor.inv = true;
            }
        }
    }
    return currentColor;
}

function invertColor (list, state, index) {
    var isInverse;
    var isColor;
    for (var i = state.length - 1; i >= 0; i--) {
        if (state[i] === 'COLOR') {
            isColor = true;
        }
        if (state[i] === 'INVERSE') {
            isInverse = true;
            state.splice(i, 1);
        }
    }

    if (list.length && isColorObj(list[list.length-1])) {
        // Invert any existing color object
        if (list[list.length-1].inv) {
            delete list[list.length-1].inv;
        } else {
            list[list.length-1].inv = true;
        }
    } else {
        var currentColor;
        if (isColor) {
            // Find current color if there and close it
            currentColor = currentColorCopy(list, state);
            closeColor(list, state);
            // Reopen as the inverse
            if (currentColor.inv) {
                delete currentColor.inv;
            } else {
                currentColor.inv = true;
            }
        } else {
            // No color or inverted, start the inverse
            currentColor = {inv: true};
        }
        list.push(currentColor);
        endColorParse('', list, state, index);
    }
    if (!isInverse) {
        state.push('INVERSE');
    }
}

function normalise (list) {
    _.each(list, function (token) {
        if (isColorObj(token)) {
            delete token.complete;
            if (token.fg === false) {
                delete token.fg;
            }
            if (token.bg === false) {
                delete token.bg;
            }
        }
    });
}

function initPrevColorState (list, state, index) {
    if (list.length) {
        if (isColorObj(list[list.length-1])) {
            // Background indicated but never specified, clear it
            if (list[list.length-1].bg === true) {
                delete list[list.length-1].bg;
                pushString(list, ',', index);
            }
            // Previous token is a color state object, start the colour state
            state.push('COLOR');
        }
    }
}

function pushString (list, chr, index) {
    list.push({val: chr, index: index});
}

// We've detected a color token, parse the next characters as color values
function parseColor (chr, colorObj, list, state, index) {
    // <code><color> - change foreground color
    // <code><color>,<color> - change foreground and background color
    // <code><color>, - change foreground, restore default background
    // <code>,<color> - change background, restore default foreground
    // <code>, - restore default foreground and background
    // <code><text> - restore default foreground and background
    
    if (chr === ',' && !('bg' in colorObj)) {
        // Comma, indicates a background
        delete colorObj._bg;
        colorObj.bg = true;
    } else if (!isNaN(parseInt(chr, 10)) || (colorObj.rgb && chr.match(RE.hex_letters))) {
        // Color code, store it appropriately
        if (colorObj.bg === true) {
            // Background indicated, start it
            colorObj.bg = chr;
        } else if ('bg' in colorObj) {
            if (colorObj.bg === false || (colorObj.rgb && colorObj.bg.length === 6)) {
                // Background color complete, end parse and start a new string
                clearOrEndColor(colorObj, chr, list, state, index);
            } else if (
                !colorObj.rgb &&
                !COLOR_MAP[colorObj.bg + chr] &&
                !EXTENDED_COLOR_MAP[colorObj.bg + chr]
            ) {
                if (colorObj.bg + chr == '99') {
                    // Transparent, clear
                    colorObj.bg = false;
                } else {
                    // Not valid color code, end it
                    endColorParse(chr, list, state, index);
                }
            } else {
                // Append to background
                colorObj.bg += chr;
            }
        } else if ('fg' in colorObj) {
            if (colorObj.fg === false || (colorObj.rgb && colorObj.fg.length === 6)) {
                // Color foreground complete, end parse and start a new string
                clearOrEndColor(colorObj, chr, list, state, index);
            } else if (
                !colorObj.rgb &&
                !COLOR_MAP[colorObj.fg + chr] &&
                !EXTENDED_COLOR_MAP[colorObj.fg + chr]
            ) {
                if (colorObj.fg + chr == '99') {
                    // Transparent, clear
                    colorObj.fg = false;
                } else {
                    // Not valid color code, end it
                    endColorParse(chr, list, state, index);
                }
            } else {
                // Append to foreground
                colorObj.fg += chr;
            }
        } else {
            // Start foreground
            colorObj.fg = chr;
        }
    } else {
        // Invalid color code character
        
        // Background indicated but never specified, clear it
        if (colorObj.bg === true) {
            delete colorObj.bg;
            chr = ',' + chr;
        }
        clearOrEndColor(colorObj, chr, list, state, index);
    }
}

function clearOrEndColor (colorObj, chr, list, state, index) {
    if (isEmptyColor(colorObj)) {
        // Color obj is empty, must have been a closer. Character starts a new string
        clearEmptyColor(list, state);
        pushString(list, chr, index);
    } else {
        // Color obj has value, end the parser and start a new string
        endColorParse(chr, list, state, index);
    }
}

// Parse each character from a string
function parseToken (chr, list, state, i, options) {
    if (options.isFormatted) {
        if (chr === CLEAR) {
            initPrevColorState(list, state, i);
            // Clear all format state
            clearState(list, state);
            return;
        } else if (chr === INVERSE || chr === INVERSE_ALT) {
            // Invert colors
            clearEmptyColor(list, state);
            initPrevColorState(list, state, i);
            invertColor(list, state, i);
            return;
        } else if (chr === COLOR) {
            // Got a color token, push a color obj
            clearEmptyColor(list, state);
            initPrevColorState(list, state, i);
            var color = currentColorCopyDefault(list, state);
            closeColor(list, state);
            list.push(color);
            return;
        } else if (chr === RGB) {
            // Got an RBG color token, push a color obj
            clearEmptyColor(list, state);
            initPrevColorState(list, state, i);
            var rgbColor = currentColorCopyDefault(list, state, true);
            closeColor(list, state);
            list.push(rgbColor);
            return;
        }
    }
    var listLen = list.length;
    if (options.isFormatted) {
        var token = TOKENS[chr];
        // Must be a regular character or token
        if (token) {
            if (listLen) {
                // Got a formatting token, push a constant
                clearEmptyColor(list, state);
                initPrevColorState(list, state, i);
                pushToken(token, list, state);
            } else {
                // Got a formatting token, push a constant
                pushToken(token, list, state);
            }
            return;
        }
    }
    if (listLen) {
        var prevIdx = listLen-1;
        if (isStringObj(list[prevIdx])) {
            // Previous token is a string, append this character to it
            list[prevIdx].val += chr;
        } else if (isColorObj(list[prevIdx])) {
            if (list[prevIdx].complete) {
                endColorParse(chr, list, state, i);
            } else {
                // Previous token is a color state object, try to parse this character as a color code
                parseColor(chr, list[prevIdx], list, state, i);
            }
        } else {
            // Previous token must be a formatting constant. This character should start a new string
            pushString(list, chr, i);
        }
    } else {
        // Empty token list. This character starts a new string
        pushString(list, chr, i);
    }
}

// https://defs.ircdocs.horse/info/formatting.html
// Previously: http://www.visualirc.net/tech-attrs.php (the info on inverse is contradictory)
var TOKENS = {
    '\u0002': 'BOLD',
    '\u0011': 'MONOSPACE',
    '\u001d': 'ITALIC',
    '\u001e': 'STRIKE',
    '\u001f': 'UNDERLINE'
};

var COLOR = '\u0003';
var RGB   = '\u0004';
var CLEAR = '\u000f';
var INVERSE = '\u0012';
var INVERSE_ALT = '\u0016';

var BLOCK = '```';
var CODE = '`';
var QUOTE = '>';

// Strip mIRC colors
var RE = {
    format_one: /[\u0002\u0003\u0004\u000f\u0011\u0012\u0016\u001d\u001e\u001f]/,
    // Doesn't strip \u0009 (TAB \t) \u000a (LF \n)  \u000d (CR \r)
    control: /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f-\u009f]/g,
    // mIRC colors
    color: /\u0003(?:\d{1,2}(?:,\d{1,2})?)?/g,
    // Hex colors
    hex: /\u0004(?:[\da-f]{6,6}(?:,[\da-f]{6,6})?)?/ig,
    hex_letters: /[a-f]/i,
    formatting: new RegExp('[' + _.keys(TOKENS).join('') + CLEAR + ']', 'g'),
    block: new RegExp(BLOCK + '([\\s\\S]+?)' + BLOCK + '(?=(?!`)[\\W\\s\\n]|$)', 'g'),
    block_one: new RegExp(BLOCK + '([\\s\\S]+?)' + BLOCK + '(?=(?!`)[\\W\\s\\n]|$)'),
    code: new RegExp(CODE + '([^`\\n]+?)' + CODE, 'gm'),
    blockquote: new RegExp('^' + QUOTE + '(?:$|(?![<>:;]|[\\W_](?:[<>](?=\\s|$)))(.+)?)', 'gm'),
    blockquote_one: new RegExp('^' + QUOTE + '(?:$|(?![<>:;]|[\\W_](?:[<>](?=\\s|$)))(.+)?)', 'm'),
    all_space: /^ +$/,
    start_space: /^ +/,
    space: / /g,
    amp: /&/g,
    lt: /</g,
    gt: />/g,
    double_quote: /"/g,
    single_quote: /'/g,
    slash: /\//g
};

var TAGS = {
    BOLD: ['b'],
    MONOSPACE: ['tt'],
    ITALIC: ['i'],
    UNDERLINE: ['u'],
    STRIKE: ['del']
};

var TOKEN_TAGS = {};
var TOKEN_CONST = {};
var c = 0;
var v, open;
for (var k in TAGS) {
    TOKEN_CONST['OPEN_' + k] = ++c;
    v = TAGS[k];
    open = '<wbr><' + v[0];
    if (v[1]) {
        open += ' class="' + v[1] + '"';
    }
    open += '>';
    TOKEN_TAGS[c] = open;
    
    TOKEN_CONST['CLOSE_' + k] = ++c;
    TOKEN_TAGS[c] = '</' + v[0] + '>';
}
TOKEN_CONST.CLOSE_COLOR = ++c;
TOKEN_TAGS[c] = '</span>';

// blockquote
TOKEN_CONST.OPEN_QUOTE = ++c;
TOKEN_TAGS[c] = '<span class="g">&gt;</span><blockquote class="quote">';
TOKEN_CONST.OPEN_QUOTE_SPACE = ++c;
TOKEN_TAGS[c] = '<span class="g">&gt; </span><blockquote class="quote">';

TOKEN_CONST.CLOSE_QUOTE = ++c;
TOKEN_TAGS[c] = '</blockquote>';
TOKEN_CONST.CLOSE_QUOTE_SPACE = ++c;
TOKEN_TAGS[c] = '</blockquote>';

// code block
TOKEN_CONST.OPEN_BLOCK = ++c;
TOKEN_TAGS[c] = '<span class="g">```</span><pre class="monoblock">';

TOKEN_CONST.CLOSE_BLOCK = ++c;
TOKEN_TAGS[c] = '</pre><span class="g">```</span>';

// code span
TOKEN_CONST.OPEN_CODE = ++c;
TOKEN_TAGS[c] = '<span class="g">`</span><tt>';

TOKEN_CONST.CLOSE_CODE = ++c;
TOKEN_TAGS[c] = '</tt><span class="g">`</span>';

// inert code span
TOKEN_CONST.OPEN_INERT_CODE = ++c;
TOKEN_TAGS[c] = '`';

TOKEN_CONST.CLOSE_INERT_CODE = ++c;
TOKEN_TAGS[c] = '`';

// http://www.mirc.com/help/colors.html
var COLOR_MAP = {
    'inverse': 'inverse',
    '00': 'white',
    '0': 'white',
    '01': 'black',
    '1': 'black',
    '02': 'navy',
    '2': 'navy',
    '03': 'green',
    '3': 'green',
    '04': 'red',
    '4': 'red',
    '05': 'maroon',
    '5': 'maroon',
    '06': 'purple',
    '6': 'purple',
    '07': 'orange',
    '7': 'orange',
    '08': 'yellow',
    '8': 'yellow',
    '09': 'lime',
    '9': 'lime',
    '10': 'teal',
    '11': 'cyan',
    '12': 'blue',
    '13': 'magenta',
    '14': 'grey',
    '15': 'silver'
};
// http://anti.teamidiot.de/static/nei/*/extended_mirc_color_proposal.html
var EXTENDED_COLOR_MAP = {
    '16': '470000',
    '17': '472100',
    '18': '474700',
    '19': '324700',
    '20': '004700',
    '21': '00472c',
    '22': '004747',
    '23': '002747',
    '24': '000047',
    '25': '2e0047',
    '26': '470047',
    '27': '47002a',
    '28': '740000',
    '29': '743a00',
    '30': '747400',
    '31': '517400',
    '32': '007400',
    '33': '007449',
    '34': '007474',
    '35': '004074',
    '36': '000074',
    '37': '4b0074',
    '38': '740074',
    '39': '740045',
    '40': 'b50000',
    '41': 'b56300',
    '42': 'b5b500',
    '43': '7db500',
    '44': '00b500',
    '45': '00b571',
    '46': '00b5b5',
    '47': '0063b5',
    '48': '0000b5',
    '49': '7500b5',
    '50': 'b500b5',
    '51': 'b5006b',
    '52': 'ff0000',
    '53': 'ff8c00',
    '54': 'ffff00',
    '55': 'b2ff00',
    '56': '00ff00',
    '57': '00ffa0',
    '58': '00ffff',
    '59': '008cff',
    '60': '0000ff',
    '61': 'a500ff',
    '62': 'ff00ff',
    '63': 'ff0098',
    '64': 'ff5959',
    '65': 'ffb459',
    '66': 'ffff71',
    '67': 'cfff60',
    '68': '6fff6f',
    '69': '65ffc9',
    '70': '6dffff',
    '71': '59b4ff',
    '72': '5959ff',
    '73': 'c459ff',
    '74': 'ff66ff',
    '75': 'ff59bc',
    '76': 'ff9c9c',
    '77': 'ffd39c',
    '78': 'ffff9c',
    '79': 'e2ff9c',
    '80': '9cff9c',
    '81': '9cffdb',
    '82': '9cffff',
    '83': '9cd3ff',
    '84': '9c9cff',
    '85': 'dc9cff',
    '86': 'ff9cff',
    '87': 'ff94d3',
    '88': '000000',
    '89': '131313',
    '90': '282828',
    '91': '363636',
    '92': '4d4d4d',
    '93': '656565',
    '94': '818181',
    '95': '9f9f9f',
    '96': 'bcbcbc',
    '97': 'e2e2e2',
    '98': 'ffffff'
};

// Helpers
function lastIndexOf (value, array) {
    if (array.lastIndexOf) {
        return array.lastIndexOf(value);
    }
    if (!array.length) {
        return -1;
    }
    for (var i = array.length - 1; i >= 0; i--) {
        if (array[i] === value) return i;
    }
    return -1;
}
function isObject (obj) {
    return Object.prototype.toString.call(obj) == '[object Object]';
}
function isNumber (obj) {
    return Object.prototype.toString.call(obj) == '[object Number]';
}

module.exports = {
    renderHtml: renderHtml,
    escapeHtml: escapeHtml,
    escapeHtmlMinimal: escapeHtmlMinimal,
    escapeHtmlLinuxNotification: escapeHtmlLinuxNotification,
    strip: strip,
    stripRegex: stripRegex,
    stripPreformatted: stripPreformatted,
    stripZWSP: stripZWSP,
    isQuote: isQuote,
    _tokenize: tokenize,
    _TOKEN_CONST: TOKEN_CONST
};



//////////////////
// WEBPACK FOOTER
// ./app/src/format/ircformatter.js
// module id = XiBv
// module chunks = 1